module.exports = __webpack_public_path__ + "img/infomap.acc124db.png";